import { Alert } from "@mui/material";
import Grid from "@mui/material/Grid";

export const NoDataFound = ({ type = "Daten", ...props }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Alert severity="info">Keine {type} gefunden</Alert>
        </Grid>
      </Grid>
    </>
  );
};
